<script setup>

const props = defineProps({
  title: { type: String, default: '' },
  iconImg: { type: String, default: '' },
  classData: { type: Array, default: () => [] }
});

const yLabels = ['100%', '80%', '60%', '40%', '20%', '0%'];

const levelColors = {
  4: '#0F61AE', 
  3: '#3C91DC', 
  2: '#66CCFF', 
  1: '#C8E4FF' 
};
</script>

<template>
  <div class="class-bar-chart">       
    <h5 class="chart-title"><img :src="iconImg" alt="" class="title-icon" />{{ title }}</h5>
    
    <div class="chart-container">
      <div class="y-axis">
        <span v-for="label in yLabels" :key="label">{{ label }}</span>
      </div>

      <div class="chart-body">
        <div class="grid-lines">
          <div v-for="n in 6" :key="n" class="line"></div>
        </div>

        <div class="bars-area">
            <div v-for="(item, idx) in classData" :key="idx" class="bar-group">
                <div class="bar-wrapper">
                <div class="bar-info">
                    <span class="value">{{ item.value.toFixed(1) }}</span>                   
                </div>
                
                <div 
                    class="bar-fill" 
                    :style="{ 
                    height: item.value + '%', 
                    backgroundColor: item.color || levelColors[item.level] 
                    }"
                ></div>
                </div>
                <span class="class-name">{{ item.className }}</span>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.class-bar-chart {
  background: var(--smoe-white);
  padding: 1rem 1.5rem 2rem;
  border-radius: 8px;  
  border: 1px solid var(--result-ai-border);
  .chart-title {
    text-align: center;
    font-family: var(--smoe-font-visual);    
    font-weight: 600;
    padding: .5rem 0;
    border-top:  2px solid var(--result-ai-primary-100);
    border-bottom: 3px solid var(--result-ai-primary-100);   
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    img { max-width: 1.5rem; }
  }
  .chart-container {
    display: flex;
    height: 230px;
    position: relative;
    padding: 3rem 0 1rem;
  }
  .y-axis {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 50px;
    font-size: 1rem;
    font-weight: 500;
    color: var(--result-ai-primary-800);
    text-align: right;
    padding-right: 10px;
    line-height: 0;
  }
  .chart-body {
    flex: 1;
    position: relative;
    
  }
  .grid-lines {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .line {
      border-top: 1px dotted #ddd;
      height: 0;
    }
  }
  .bars-area {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    padding: 0 10px;
    z-index: 1;
  }
  .bar-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;

    .bar-wrapper {
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      position: relative;
    }
    .bar-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 5px;
      line-height: 1.2;
      .value { font-weight: 700; font-size: 1rem; }
      .level { font-size: 1rem; color: #333; font-weight: 600; }
    }
    .bar-fill {
      width: 30px;
      border-radius: 4px 4px 0 0;
    }
    .class-name { 
      font-size: 1rem;
      font-weight: 600;
      position: absolute;
      bottom: -30px;
    }
  }
}
</style>